import { GiSelfLove } from "react-icons/gi";
import { AiFillSchedule } from "react-icons/ai";
import { SiWorkplace } from "react-icons/si";
import { VscWorkspaceTrusted } from "react-icons/vsc";
import "./PromotionalFeatures.scss";
import { BBICounselorSchedule, BBIEnrollmentHandbook } from "../../../../../assets";

type CustomStyle = {
	"--accent-color": string;
};

const PromotinalFeatures: React.FC = (): JSX.Element => {
	const bannerStyle: CustomStyle = {
		"--accent-color": "#D7263D"
	};

	const bannerStyle2: CustomStyle = {
		"--accent-color": "#3652AD"
	};

	const bannerStyle3: CustomStyle = {
		"--accent-color": "#16302B"
	};

	const bannerStyle4: CustomStyle = {
		"--accent-color": "#071952"
	};

	const redirectMemberPortal = () => {
		const path = "https://member.enrollment.nexcaliber.com";
		window.open(path);
	};

	// const handleRedirectToEnrollerPortal = () => {
	// 	const path = "https://schedapple.com/appointment/12455?location=2&service=&staff=&hide_go_back=n";
	// 	window.open(path);
	// };

	return (
		<>
			<div>
				<ul className="start-banner">
					<li className="banner-li-1" style={bannerStyle as never}>
						<div className="icon">
							<AiFillSchedule />
						</div>
						<div className="title">
							Schedule a call with an enroller
							<br />
							<span className="mini-text">MON-FRI 8 AM to 6 PM</span>
						</div>
						<div className="button-container">
							{/* <button
								className="pulse-button"
								style={{ fontWeight: "500" }}
								onClick={handleRedirectToEnrollerPortal}
							>
								Make Appointment
							</button> */}
							<p className="pulse-texts">
								Benefits Call Center 833-356-0852 <br />
							</p>
						</div>

						<div className="enroller-container"></div>
					</li>
					<li className="banner-li" style={bannerStyle2 as never}>
						<div className="icon">
							<GiSelfLove />
						</div>
						<div className="title">
							Self-Service <br /> Enroll on your own, without an agent
						</div>
						<div className="button-container">
							<button
								className="pulse-button"
								style={{ marginTop: "-1px" }}
								onClick={redirectMemberPortal}
							>
								Self-Service
							</button>
						</div>
					</li>

					<li className="banner-li" style={bannerStyle4 as never}>
						<div className="icon">
							<VscWorkspaceTrusted />
						</div>
						<div className="title">View our Benefits Guidebook</div>
						<div className="button-container">
							{/* <button className="pulse-button" onClick={redirectNexcaliberSite}>
								Download
							</button> */}
							<div className="button-container">
								<button
									className="button"
									type="button"
									onClick={() => window.open(BBIEnrollmentHandbook, "_blank")}
								>
									<span className="button__text">Handbook</span>
									<span className="button__icon">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 35 35"
											id="bdd05811-e15d-428c-bb53-8661459f9307"
											data-name="Layer 2"
											className="svg"
										>
											<path d="M17.5,22.131a1.249,1.249,0,0,1-1.25-1.25V2.187a1.25,1.25,0,0,1,2.5,0V20.881A1.25,1.25,0,0,1,17.5,22.131Z"></path>
											<path d="M17.5,22.693a3.189,3.189,0,0,1-2.262-.936L8.487,15.006a1.249,1.249,0,0,1,1.767-1.767l6.751,6.751a.7.7,0,0,0,.99,0l6.751-6.751a1.25,1.25,0,0,1,1.768,1.767l-6.752,6.751A3.191,3.191,0,0,1,17.5,22.693Z"></path>
											<path d="M31.436,34.063H3.564A3.318,3.318,0,0,1,.25,30.749V22.011a1.25,1.25,0,0,1,2.5,0v8.738a.815.815,0,0,0,.814.814H31.436a.815.815,0,0,0,.814-.814V22.011a1.25,1.25,0,1,1,2.5,0v8.738A3.318,3.318,0,0,1,31.436,34.063Z"></path>
										</svg>
									</span>
								</button>
							</div>
						</div>
					</li>

					<li className="banner-li-1" style={bannerStyle3 as never}>
						<div className="icon">
							<SiWorkplace />
						</div>
						<div className="title">Visit with an enroller at your work location</div>
						{/* <button className="download-button">Download Excel</button> */}
						<div className="button-container">
							<button
								className="button"
								type="button"
								onClick={() => window.open(BBICounselorSchedule, "_blank")}
							>
								<span className="button__text">Schedule</span>
								<span className="button__icon">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 35 35"
										id="bdd05811-e15d-428c-bb53-8661459f9307"
										data-name="Layer 2"
										className="svg"
									>
										<path d="M17.5,22.131a1.249,1.249,0,0,1-1.25-1.25V2.187a1.25,1.25,0,0,1,2.5,0V20.881A1.25,1.25,0,0,1,17.5,22.131Z"></path>
										<path d="M17.5,22.693a3.189,3.189,0,0,1-2.262-.936L8.487,15.006a1.249,1.249,0,0,1,1.767-1.767l6.751,6.751a.7.7,0,0,0,.99,0l6.751-6.751a1.25,1.25,0,0,1,1.768,1.767l-6.752,6.751A3.191,3.191,0,0,1,17.5,22.693Z"></path>
										<path d="M31.436,34.063H3.564A3.318,3.318,0,0,1,.25,30.749V22.011a1.25,1.25,0,0,1,2.5,0v8.738a.815.815,0,0,0,.814.814H31.436a.815.815,0,0,0,.814-.814V22.011a1.25,1.25,0,1,1,2.5,0v8.738A3.318,3.318,0,0,1,31.436,34.063Z"></path>
									</svg>
								</span>
							</button>
						</div>
					</li>
				</ul>
			</div>
		</>
	);
};

export default PromotinalFeatures;
